import React from 'react'

const Wishlist = ({ width, height }) => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 14.9 14.922"
      >
        <g transform="translate(-1.55 -1.528)">
          <path
            data-name="Path 945"
            d="m7.4 11.8 6.1-.509c1.91-.159 2.339-.576 2.55-2.481l.45-4.01M6 4.8h.7m10.5 0h-1.4M9.161 2.271a1.574 1.574 0 0 1 1.8.02c.161.118.242.177.29.177s.128-.059.29-.177a1.574 1.574 0 0 1 1.8-.02c.986.588 1.208 2.526-1.064 4.162a1.659 1.659 0 0 1-1.027.467 1.654 1.654 0 0 1-1.025-.468C7.952 4.8 8.175 2.858 9.161 2.271"
            transform="translate(-1.2)"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
          <circle
            data-name="Ellipse 156"
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="translate(3 13)"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
          <circle
            data-name="Ellipse 157"
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="translate(11 13)"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
          <path
            data-name="Path 946"
            d="M6.2 14.6h4.9M2 2h.676a1.434 1.434 0 0 1 1.4 1.06l2.084 8.093a1.372 1.372 0 0 1-.245 1.18l-.671.867"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
        </g>
      </svg>
    </div>
  )
}

export default Wishlist
